import { render, staticRenderFns } from "./Switchover.vue?vue&type=template&id=fadb3632&"
import script from "./Switchover.vue?vue&type=script&lang=js&"
export * from "./Switchover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports